import { TAO_KOE, TaoToaster } from './../libs';

class LocationSearchForm {
	constructor( formEl ) {
		this.formEl = formEl;
		this.buttonEl = this.formEl.querySelector( '.tao-current-location' );

		if ( this.hasGeolocation() ) {
			this.buttonEl.addEventListener( 'click', ( ev ) => {
				ev.preventDefault();
				LocationSearchForm.geolocate().then( ( res ) => {
					window.location = '?lat=' + res.coords.latitude + '&lng=' + res.coords.longitude;
				} );
			} );
		}
	}

	hasGeolocation() {
		return 'geolocation' in navigator;
	}

	static geolocate() {
		return new Promise( ( resolve, reject ) => {
			navigator.geolocation.getCurrentPosition( ( res ) => {
				resolve( res );
			}, ( err ) => {
				switch ( err.code ) {
					case 1:
						TaoToaster.toast( 'Bitte aktivieren Sie die Funktion zur Standortbestimmung!', 'error' );
						break;

					default:
						TaoToaster.toast( 'Leider konnten wir Ihren Standort nicht bestimmen!', 'error' );
						break;
				}

				reject( err );
			} );
		} );
	}
}

const initLocationSearchForm = ( scopeEl = document ) => {
	scopeEl.querySelectorAll( '.tao-location-search' ).forEach( ( formEl ) => {
		formEl.KOA_LOCATION_SEARCH_FORM ??= new LocationSearchForm( formEl );
	} );
};

// Init.
TAO_KOE.ready( 'location.js', () => initLocationSearchForm() );

// Expose.
TAO_KOE.Locations = LocationSearchForm;
export {
	LocationSearchForm as default,
	initLocationSearchForm,
};
